import React from "react";
import Notes from "../../components/Notes/Notes";
import { useParams } from "react-router-dom";
function NotesSection() {
  const { rma_id } = useParams();

  console.log("order_id", rma_id);
  return (
    <>
      <Notes module_type={"RMA"} module_id={rma_id} />
    </>
  );
}

export default NotesSection;
